import { createContext, useContext } from "react";

import type { BranchRouter } from "./branchRouter";
import type { DemoBranchStore } from "./DemoBranchStore";

export interface BranchWizardContextValue {
  branchStore: DemoBranchStore;
  router: BranchRouter;
  onSubmit?: () => Promise<boolean | string>;
}

const BranchWizardContext = createContext<BranchWizardContextValue | null>(
  null
);

export const useBranchWizardContext = () => {
  const context = useContext(BranchWizardContext);
  if (!context) {
    throw new Error(
      "useBranchWizardContext must be used within BranchWizardProvider"
    );
  }
  return context;
};

export const BranchWizardProvider = BranchWizardContext.Provider;
